export default "__VITE_PUBLIC_ASSET__b6018eb9__"